// snake_case to camelCase
export function snakeToCamel<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(snakeToCamel) as T;
  } else if (obj !== null && typeof obj === "object" && obj.constructor === Object) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.replace(/_([a-zA-Z0-9])/g, (_, c) => c.toUpperCase()),
        snakeToCamel(value),
      ]),
    ) as T;
  }
  return obj;
}

// camelCase to snake_case
export function camelToSnake<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(camelToSnake) as T;
  } else if (obj !== null && typeof obj === "object" && obj.constructor === Object) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.replace(/([A-Z])/g, "_$1").toLowerCase(),
        camelToSnake(value),
      ]),
    ) as T;
  }
  return obj;
}
